<div class="affiliate-code-details-view-container"  fxLayout="column" fxLayoutGap="15px"  *ngIf="affiliateCodeObject">
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + affiliateCodeObject?.status?.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="affiliateCodeObject?.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button
      *ngIf="(userPermissions | async).partner?.admin_root"
      [disabled]="!(userPermissions | async).partner?.admin_root"
      mat-stroked-button (click)="modify()"
    ><mat-icon>create</mat-icon><span> Edytuj</span></button>
    <button
      *ngIf="(userPermissions | async).partner?.admin_root && affiliateCodeObject.status?.key === AFFILIATE_CODE_STATUS_ACTIVE"
      [disabled]="!(userPermissions | async).partner?.admin_root"
      mat-stroked-button (click)="delete()"
    ><mat-icon>delete</mat-icon><span> Zablokuj kod</span></button>
    <button
      *ngIf="(userPermissions | async).partner?.admin_root && affiliateCodeObject.status?.key === AFFILIATE_CODE_STATUS_INACTIVE"
      [disabled]="!(userPermissions | async).partner?.admin_root"
      mat-stroked-button (click)="restore()"
    ><mat-icon>restore_from_trash</mat-icon><span> Odblokuj kod</span></button>

    <button
      mat-stroked-button
      [style.visibility]="'hidden'"
    ><span>edit</span></button>


  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="affiliateCodeObject.status?.key === AFFILIATE_CODE_STATUS_ACTIVE? 50: 100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane </h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Kod" [value]="affiliateCodeObject.code"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Opis kodu" [value]="affiliateCodeObject.name"></app-detail>
              </div>
            </div>
            <div fxLayout="row">
              <h2 >Dane kontaktowe opiekuna polis</h2>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Imię" [value]="affiliateCodeObject.firstName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwisko" [value]="affiliateCodeObject.lastName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Adres email" [value]="affiliateCodeObject.email"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer telefonu" [value]="affiliateCodeObject.phone"></app-detail>
              </div>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Partner" [value]="affiliateCodeObject.partner?.fullName" [link]="['/partnerzy/szczegoly', affiliateCodeObject.partner?.uuid]"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="OFWCA" [value]="affiliateCodeObject.ofwca?.fullName" [link]="affiliateCodeObject.ofwca ? ['/ofwca/szczegoly', affiliateCodeObject.ofwca?.uuid] : undefined"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail-bool header="Kod główny" [value]="affiliateCodeObject.main"></app-detail-bool>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>


    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" *ngIf="affiliateCodeObject.status?.key === AFFILIATE_CODE_STATUS_ACTIVE">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Linki</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngFor="let prefix of link">
              <div fxFlex="100">
                <app-detail
                  header="Link"
                  [value]="prefix + affiliateCodeObject.code">
                </app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>


